import { playerCardCondensedSize } from "@/design-system/PlayerCard/PlayerCardCondensed";
import { playerPlaceHolderIcon } from "@/icons";

/**
 * A starting position with nobody in it: the squad builder's empty-slot
 * card, at a condensed player card's footprint so it lines up with the
 * cards around it.
 */
export const EmptySlotCard = ({ scale }: { scale: number }) => (
  <div
    style={playerCardCondensedSize(scale)}
    className="flex flex-none items-center justify-center opacity-50 [&>svg]:h-4/5 [&>svg]:w-auto"
    aria-hidden
  >
    {playerPlaceHolderIcon(false, false)}
  </div>
);
